import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { shouldForwardProp } from '@/utils/style.utils';
import { COLOR_VARIANTS, CircleIcons, color } from '@tajawal/ct-web-design-system';
import { CustomTheme } from '@tajawal/ct-web-design-system/dist/theme';

export const BaggageItem = styled.div<{ $isWhiteIcon?: boolean }>`
  display: flex;
  gap: 8px;

  & > svg:nth-of-type(1) > path:nth-of-type(1) {
    fill: ${({ $isWhiteIcon }) => $isWhiteIcon && color(COLOR_VARIANTS.WHITE)};
  }

  a {
    align-self: center;
  }
`;

export const BaggageTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 2px 0;
`;

export const CheckIcon = styled(CircleIcons.Check, { shouldForwardProp })<{ $isExtra: boolean }>`
  ${({ $isExtra }) =>
    $isExtra &&
    css`
      path {
        &:first-of-type {
          fill: ${color(COLOR_VARIANTS.AQUA10)};
        }
        &:last-of-type {
          stroke: ${color(COLOR_VARIANTS.AQUA100)};
        }
      }
    `}
`;

const CircleIcon = styled(CircleIcons.Arrow)`
  transform: ${({ theme }: { theme?: CustomTheme }) => theme.isRtl && 'rotateY(180deg)'};
`;

export default {
  BaggageItem,
  BaggageTextWrapper,
  CheckIcon,
  CircleIcon,
};
